module.exports = __webpack_public_path__ + "img/icon-search.dabff2f5.svg";